import { toast as toastBurnt } from "burnt";
import { ToastOptions } from "./types";

const toast = (options: ToastOptions) => {
	return toastBurnt(options);
};

export default toast;
